import { render, staticRenderFns } from "./BioSearchSetting.vue?vue&type=template&id=bf3be4e8"
import script from "./BioSearchSetting.vue?vue&type=script&lang=js"
export * from "./BioSearchSetting.vue?vue&type=script&lang=js"
import style0 from "./BioSearchSetting.vue?vue&type=style&index=0&id=bf3be4e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports